import GCCHighLogo from '@/assets/images/gcc-high.png';

const GCCHighIcon = ({ size = 25 }) => (
    <img
        src={GCCHighLogo}
        alt="GCC High Logo"
        style={{ height: size, width: size }}
    />
);

export default GCCHighIcon;
